/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'jquery-ui/themes/base/jquery-ui.min.css';
import 'selectboxit/src/stylesheets/jquery.selectBoxIt.css';
import 'resources/less/themes/base/mobile/base.less';

import 'assets/js/modules/bootstrapTooltip';
import 'assets/js/modules/core';
import 'APP_THEME/_common/vip_level_popup/vip_level_popup';
import 'APP_THEME/_common/vip_level_tooltip/vip_level_tooltip';
import LinkTagHelper from 'APP_THEME/_common/link_tag_helper/index';

LinkTagHelper.addLink('//fonts.googleapis.com/css?family=Lato:300,400,700&display=swap');
LinkTagHelper.addLink('//netdna.bootstrapcdn.com/font-awesome/3.2.1/css/font-awesome.min.css');
